import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Desktop from "@/components/os/Desktop";
import AdminPage from "@/pages_admin/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import { playKeyClick, playBeep } from "@/lib/sound";

export default function App() {
    useEffect(() => {
        const onClick = (e) => {
            if (e.target.closest("a, button") && !e.target.closest("[data-testid='terminal-body']")) {
                playBeep(1250, 0.025, 0.02, "square");
            }
        };
        const onType = (e) => {
            if (e.target.matches("input, textarea") && e.target.dataset.testid !== "terminal-input" && (e.key.length === 1 || e.key === "Backspace")) {
                playKeyClick();
            }
        };
        document.addEventListener("click", onClick);
        document.addEventListener("keydown", onType);
        return () => {
            document.removeEventListener("click", onClick);
            document.removeEventListener("keydown", onType);
        };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Desktop />} />
                <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <Toaster position="top-center" toastOptions={{ style: { background: "#17181c", color: "#f6f5f4", border: "1px solid rgba(255,255,255,0.15)", fontFamily: "JetBrains Mono, monospace", fontSize: 12 } }} />
        </BrowserRouter>
    );
}
